/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

/**
 * A hook for subscribing to the current
 * screen zooming ratio.
 */
export const useZoomLevel = () => {
    const [zoomLevel, setZoomLevel] = React.useState(Math.round(window.devicePixelRatio * 100));
    const handler = () => setZoomLevel(Math.round(window.devicePixelRatio * 100));

    React.useEffect(() => {
        window.addEventListener('resize', handler);

        return () => window.removeEventListener('resize', handler);
    }, []);

    return { zoomLevel, isAccessibleMode: zoomLevel > 175 };
};
